module.exports = __webpack_public_path__ + "static/legend-category-label-do-ab5f0b0801947902217fad53e8ac2f00.png";